import React from 'react'
import Payment from "../components/MHSSS Accounting/outstanding/PayOutstanding/pay"

const paymentM = () => {
  return (
    <div>
     <Payment/>
    </div>
  )
}

export default paymentM